import React from "react";
import { AlertTriangle } from "lucide-react";

const snapshotStorage = () => {
  const out = {};
  try {
    Object.keys(localStorage).forEach((k) => {
      if (/^(spore|subterra)/.test(k)) out[k] = String(localStorage.getItem(k)).slice(0, 2000);
    });
  } catch {
    out.error = "localStorage unavailable";
  }
  return out;
};

export const reportClientError = (error, componentStack = "") => {
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-errors`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      message: String(error?.message || error).slice(0, 2000),
      stack: String(error?.stack || "").slice(0, 8000),
      component_stack: String(componentStack).slice(0, 8000),
      url: window.location.href.slice(0, 500),
      user_agent: navigator.userAgent.slice(0, 500),
      storage: snapshotStorage(),
    }),
  }).catch(() => {});
};

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    reportClientError(error, info?.componentStack);
  }

  reset = () => {
    ["spore_progress", "spore_index_checked"].forEach((k) => localStorage.removeItem(k));
    window.location.assign("/");
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="error-boundary" className="min-h-screen bg-[#070A0E] text-slate-100 flex items-center justify-center p-6">
        <div className="max-w-md w-full rounded-sm border border-red-500/50 bg-[#121824] p-8 space-y-5 text-center">
          <AlertTriangle className="h-10 w-10 text-[#FF2E63] mx-auto" />
          <p className="font-display uppercase font-bold text-2xl">Containment fault</p>
          <p className="text-slate-400 text-sm">Something went wrong loading this page. Resetting the saved game data on this device usually fixes it.</p>
          <p data-testid="error-boundary-detail" className="font-tac text-[11px] text-red-300/80 break-words">
            {String(this.state.error?.message || this.state.error).slice(0, 200)}
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <button type="button" data-testid="error-reload-btn" onClick={() => window.location.reload()} className="flex-1 font-tac text-xs uppercase tracking-widest px-4 py-3 rounded-sm border border-slate-700 text-slate-200 hover:border-cyan-500/60">
              Reload
            </button>
            <button type="button" data-testid="error-reset-btn" onClick={this.reset} className="flex-1 font-tac text-xs uppercase tracking-widest px-4 py-3 rounded-sm border border-[#FF2E63] bg-[#FF2E63] text-black font-bold">
              Reset saved data
            </button>
          </div>
        </div>
      </div>
    );
  }
}
